import { Outlet } from "react-router-dom";

export default function Tag() {
  return <Outlet />;
}
